import store_admission from '@/store/mods/clinique/prestations'
import $ from 'jquery'

export default {
    name: 'l-type-admission',
    components: {},
    props: {
        type_admission: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_load_error: false,
            all_checked: false,
            one_is_checked: [],
            prestations: [],
            type_prestation: ''
        }
    },

    watch: {
        type_admission() {
            this.initTypeAdmission()
        }
    },

    computed: {

    },

    mounted() {
        this.initTypeAdmission()
    },

    methods: {
        initTypeAdmission() {
            this.one_is_checked = []
            this.prestations = []
            this.all_checked = false
            if (this.type_admission == 'admission') {
                this.type_prestation = 'Admission'
            } else if (this.type_admission == 'chambre') {
                this.type_prestation = 'Chambre'
            } else if (this.type_admission == 'observation') {
                this.type_prestation = 'Observation'
            }
            this.fetchTypeAdmission()
        },

        fetchTypeAdmission() {
            this.is_loading = true
            this.is_load_error = false

            const data = {
                assurance_id: 0,
                data_type: this.type_admission
            }
            store_admission.getTarificationTypeAdmission(data).then((response) => {
                this.prestations = response
                this.is_empty = this.prestations.length === 0
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_load_error = true
            })
        },

        toutSelectionner() {
            const is_checked = $('#type-admission-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = this.prestations.map((prestation) => ({ id: prestation.id, libelle: prestation.nom_prestation }))
            } else {
                this.one_is_checked = []
            }

            this.all_checked = is_checked
        }
    }
}